import siteData from '../../data/site.json'

export default function ContactInfo() {
  return (
    <div className="bg-neutral-50 rounded-lg p-8">
      <h2 className="text-2xl font-serif text-primary mb-6">Kontaktinformationen</h2>

      <div className="space-y-6">
        {/* Email */}
        <div className="flex items-start space-x-4">
          <div className="flex-shrink-0 w-12 h-12 bg-primary/10 rounded-lg flex items-center justify-center">
            <svg className="w-6 h-6 text-primary" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" />
            </svg>
          </div>
          <div>
            <h3 className="font-semibold text-neutral-800 mb-1">E-Mail</h3>
            <a
              href={`mailto:${siteData.contact.email}`}
              className="text-primary hover:text-secondary transition-colors"
            >
              {siteData.contact.email}
            </a>
          </div>
        </div>

        {/* Phone */}
        {siteData.contact.showPhone && (
          <div className="flex items-start space-x-4">
            <div className="flex-shrink-0 w-12 h-12 bg-primary/10 rounded-lg flex items-center justify-center">
              <svg className="w-6 h-6 text-primary" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z" />
              </svg>
            </div>
            <div>
              <h3 className="font-semibold text-neutral-800 mb-1">Telefon</h3>
              <a
                href={`tel:${siteData.contact.phone}`}
                className="text-primary hover:text-secondary transition-colors"
              >
                {siteData.contact.phone}
              </a>
            </div>
          </div>
        )}

        {/* Location */}
        <div className="flex items-start space-x-4">
          <div className="flex-shrink-0 w-12 h-12 bg-primary/10 rounded-lg flex items-center justify-center">
            <svg className="w-6 h-6 text-primary" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z" />
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 11a3 3 0 11-6 0 3 3 0 016 0z" />
            </svg>
          </div>
          <div>
            <h3 className="font-semibold text-neutral-800 mb-1">Standort</h3>
            <p className="text-neutral-600">Kaiserstuhl, Deutschland</p>
          </div>
        </div>
      </div>

      {/* Additional Info */}
      <div className="mt-8 pt-6 border-t border-neutral-200">
        <p className="text-sm text-neutral-600">
          Ich freue mich über Ihre Anfragen zu Kunstwerken, Ausstellungen und Auftragsarbeiten.
        </p>
      </div>
    </div>
  )
}
